import { render, staticRenderFns } from "./universal-form.vue?vue&type=template&id=d9f3db4c&scoped=true&"
import script from "./universal-form.ts?vue&type=script&lang=ts&"
export * from "./universal-form.ts?vue&type=script&lang=ts&"
import style0 from "./universal-form.scss?vue&type=style&index=0&id=d9f3db4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9f3db4c",
  null
  
)

export default component.exports